export default "__VITE_ASSET__7561bf45__"